import { Box } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LiquidGlassCircleButton } from '../common/LiquidGlassCircleButton';

interface VoiceExpandMenuAchievementProps {
  onNewAchievement: () => void;
}

export const VoiceExpandMenuAchievement: FC<VoiceExpandMenuAchievementProps> = ({
  onNewAchievement,
}) => {
  const { t } = useTranslation();
  return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '12px', width: '100%' }}>
    <Text weight="2" style={{ fontSize: 16, color: 'var(--tg-theme-text-color)' }}>
        {t('achievement.new')}
    </Text>
    <LiquidGlassCircleButton icon="emoji_events" ariaLabel={t('achievement.new')} onClick={onNewAchievement} />
  </Box>;
};
